import React from "react";

import { useTranslate } from "localization";
import { Filter } from "ui/forms";

import { useTransactionAuditStatusesQuery } from "API";

import useFilterParam from "./useFilterParam";

const AuditStatus: React.FC = () => {
  const { translate } = useTranslate();
  const title = translate("auditStatus");

  const { data = [], isSuccess, isError } = useTransactionAuditStatusesQuery();
  const [selected, setSelected] = useFilterParam("audit_status", data, {
    defaultToFirst: false,
    multi: true,
    ready: isSuccess || isError,
  });
  return (
    <Filter
      items={{ options: data }}
      title={title}
      label={title}
      selected={!!selected.length}
      count={selected.length ? selected.length : void 0}
      onChange={setSelected}
      value={selected}
      multi={true}
      showReset={true}
      showApply={true}
      translate={translate}
    />
  );
};

export default AuditStatus;
